// User roles
export const USER_ROLES = {
  PLATFORM_ADMIN: 'admin_plataforma',
  SALES: 'ventas',
  ESTABLISHMENT_ADMIN: 'admin_establecimiento',
  MANAGER: 'encargado',
  RECEPTIONIST: 'recepcionista',
  CLEANING_STAFF: 'personal_limpieza'
};

// Room statuses (from API model)
export const ROOM_STATUS = {
  DIRTY: 'dirty',
  CLEAN: 'clean',
  MAINTENANCE: 'maintenance'
};

// Order statuses
export const ORDER_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

// Incident statuses
export const INCIDENT_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed'
};

// Cleaning types
export const CLEANING_TYPES = {
  CHECKOUT: 'checkout',
  MAINTENANCE: 'maintenance',
  DEEP_CLEAN: 'deep_clean',
  INSPECTION: 'inspection'
};

// Bed configurations (from API model)
export const BED_CONFIGURATIONS = {
  INDIVIDUAL: 'individual',  // Para 1 cama
  MATRIMONIO: 'matrimonio',  // Para 2+ camas juntas
  SEPARADAS: 'separadas'     // Para 2+ camas separadas
};

// Subscription plans
export const SUBSCRIPTION_PLANS = {
  BASIC: 'basic',
  PROFESSIONAL: 'professional',
  ENTERPRISE: 'enterprise'
};

// Subscription statuses
export const SUBSCRIPTION_STATUS = {
  TRIAL: 'trial',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
  SUSPENDED: 'suspended'
};

// Subscription periods
export const SUBSCRIPTION_PERIODS = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual'
};

// Payment statuses
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded'
};

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/v1/auth/login',
    LOGOUT: '/api/v1/auth/logout',
    ME: '/api/v1/auth/me',
    REFRESH: '/api/v1/auth/refresh',
    REVOKE_REFRESH: '/api/v1/auth/revoke-refresh-token',
    REVOKE_ALL_REFRESH: '/api/v1/auth/revoke-all-refresh-tokens'
  },
  ORDERS: '/api/v1/cleaning-orders/',
  USERS: '/api/v1/users/',
  ROOMS: '/api/v1/rooms/',
  ROOM_GROUPS: '/api/v1/room-groups/',
  COMMON_SPACES: '/api/v1/common-spaces/',
  ESTABLISHMENTS: '/api/v1/establishments/',
  ESTABLISHMENT_ADDRESSES: '/api/v1/establishment-addresses/',
  INCIDENTS: '/api/v1/incidents/',
  CLEANING_TYPES: '/api/v1/cleaning-types/',
  BED_DISPOSITIONS: '/api/v1/bed-dispositions/',
  LOGIN_HISTORY: '/api/v1/login-history/',
  SUBSCRIPTIONS: '/api/v1/subscriptions/',
  WORK_SCHEDULES: '/api/v1/work-schedules/',
  SCHEDULE_SPECIAL_STATUSES: '/api/v1/schedule-special-statuses/',
  REPORTS: '/api/v1/reports/',
  TIME_ENTRIES: '/api/v1/time-entries/',
  TIME_ENTRY_MODIFICATIONS: '/api/v1/time-entry-modifications/',
  MONTH_VALIDATIONS: '/api/v1/month-validations/',
  CONTACT: '/api/v1/contact/'
};

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'hm_token',
  REFRESH_TOKEN: 'hm_refresh_token',
  USER: 'hm_user',
  ESTABLISHMENT: 'hm_establishment'
};

// Date formats
export const DATE_FORMATS = {
  DISPLAY: 'dd/MM/yyyy',
  API: 'yyyy-MM-dd',
  DATETIME: 'dd/MM/yyyy HH:mm'
};

// Error messages
export const ERROR_MESSAGES = {
  NETWORK: 'Error de conexión. Inténtalo de nuevo.',
  UNAUTHORIZED: 'No tienes permisos para realizar esta acción.',
  VALIDATION: 'Por favor, completa todos los campos requeridos.',
  GENERIC: 'Ha ocurrido un error inesperado.'
};

// Success messages
export const SUCCESS_MESSAGES = {
  ORDER_CREATED: 'Orden de limpieza creada exitosamente',
  ORDER_UPDATED: 'Orden de limpieza actualizada exitosamente',
  ORDER_COMPLETED: 'Orden marcada como completada',
  USER_CREATED: 'Usuario creado exitosamente',
  USER_UPDATED: 'Usuario actualizado exitosamente',
  ROOM_CREATED: 'Habitación creada exitosamente',
  ROOM_UPDATED: 'Habitación actualizada exitosamente',
  COMMON_SPACE_CREATED: 'Espacio común creado exitosamente',
  COMMON_SPACE_UPDATED: 'Espacio común actualizado exitosamente',
  INCIDENT_CREATED: 'Incidencia creada exitosamente',
  INCIDENT_UPDATED: 'Incidencia actualizada exitosamente',
  INCIDENT_CLOSED: 'Incidencia cerrada exitosamente',
  INCIDENT_REOPENED: 'Incidencia reabierta exitosamente',
  INCIDENT_DELETED: 'Incidencia eliminada exitosamente',
  SUBSCRIPTION_CREATED: 'Suscripción creada exitosamente',
  SUBSCRIPTION_UPDATED: 'Suscripción actualizada exitosamente',
  SUBSCRIPTION_CANCELED: 'Suscripción cancelada exitosamente',
  PLAN_CREATED: 'Plan creado exitosamente',
  PLAN_UPDATED: 'Plan actualizado exitosamente'
};